export default "__VITE_ASSET__CUKRS6PP__"